import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  PageResponse,
  StaffBenefitDecisionRequest,
  StaffBenefitRequestCreateRequest,
  StaffBenefitRequestResponse,
  StaffBenefitRequestStatus,
} from "../model/benefit.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffBenefitRequestsService {
  private readonly apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.apiUrl = `${basePath.replace(/\/$/, "")}/api/v1/benefit-requests`;
  }

  list(filters?: {
    companyId?: number;
    employeeId?: number;
    benefitId?: number;
    status?: StaffBenefitRequestStatus;
  }): Observable<PageResponse<StaffBenefitRequestResponse>> {
    let params = new HttpParams();

    if (filters?.companyId != null)
      params = params.set("companyId", filters.companyId);
    if (filters?.employeeId != null)
      params = params.set("employeeId", filters.employeeId);
    if (filters?.benefitId != null)
      params = params.set("benefitId", filters.benefitId);
    if (filters?.status) params = params.set("status", filters.status);

    return this.http.get<PageResponse<StaffBenefitRequestResponse>>(
      this.apiUrl,
      {
        params,
      },
    );
  }

  getById(benefitRequestId: number): Observable<StaffBenefitRequestResponse> {
    return this.http.get<StaffBenefitRequestResponse>(
      `${this.apiUrl}/${benefitRequestId}`,
    );
  }

  create(
    request: StaffBenefitRequestCreateRequest,
  ): Observable<StaffBenefitRequestResponse> {
    return this.http.post<StaffBenefitRequestResponse>(this.apiUrl, request);
  }

  decide(
    benefitRequestId: number,
    request: StaffBenefitDecisionRequest,
  ): Observable<StaffBenefitRequestResponse> {
    return this.http.patch<StaffBenefitRequestResponse>(
      `${this.apiUrl}/${benefitRequestId}/decision`,
      request,
    );
  }

  cancel(benefitRequestId: number): Observable<StaffBenefitRequestResponse> {
    return this.http.delete<StaffBenefitRequestResponse>(
      `${this.apiUrl}/${benefitRequestId}`,
    );
  }
}
